import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Avatar } from "@material-ui/core";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../Shared/Loading";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Skeleton from "@mui/material/Skeleton";
import Checkbox from "@material-ui/core/Checkbox";

const SelectTable = ({
  numSelectedRows,
  users,
  selectAllClicked,
  handleSelectAllUsers,
  userPage,
  usersPerPage,
  handleRowSelectionChanged,
  selectedUsers,
  handleOpenDeleteUserDialog,
  handlePageBack,
  handlePageForward,
  finalPageCount,
  handleUserClick,
  loading,
  loadingUsers,
  search,
  returnGroupName,
}) => {
  const useStyles = makeStyles((theme) => ({
    containerStyles: {
      "&.MuiContainer-root": {
        [theme.breakpoints.down("md")]: {
          paddingLeft: "5px",
          paddingRight: "5px",
        },
      },
    },
    userAccessStyles: {
      fontFamily: "poppins, sans-serif",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    componentHeadingStyles: {},

    search: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
    },

    searchField: {
      marginLeft: "2vh",
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginBottom: "0.5rem",
      },
    },
    selectUserGroup: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        marginBottom: "0.5rem",
      },
    },
    label: { display: "flex", alignItems: "center", marginRight: "4vh" },
    dropdown: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      marginRight: "5%",
      backgroundColor: "#f7f7f7",
      height: "2.5rem",
      width: "15rem",
      lineHeight: "2rem",
    },
    menuItems: { display: "block" },

    SelectUserTitleLeft: {
      marginTop: "1vh",
      marginBottom: "1vh",
      display: "flex",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between",
        marginTop: "0.5rem",
      },
    },
    SaveButtonRight: {
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        justifyContent: "space-between",
        marginTop: "0.5rem",
      },
    },

    searchBoxStyles: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      paddingTop: "0.6rem",
      paddingBottom: "0.6rem",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },

    btnStyles: {
      background: "#1B2132",
      color: "#fff",
      fontSize: ".8rem",
    },

    tableBtn: {
      background: "#1b2132",
    },

    searchBtnStyles: {
      fontSize: ".8rem",
    },

    tableContainer: {
      margin: "1rem 0",
    },

    tableHeaderStyles: {
      fontWeight: "bold",
    },
    tableCellStyles: {
      width: "24vh",
    },
    tableCellStylesSrNum: {
      width: "5vh",
      alignItems: "center",
    },
    cta: {
      display: "flex",
      justifyContent: "flex-end",
    },

    saveBtnStyles: {
      width: "10rem",
    },

    userGroups: {
      cursor: "pointer",
      minWidth: "24vh",
      "&:hover": {
        textDecoration: "underline",
      },
    },

    deleteIconStyles: {
      "&:hover": {
        color: "red",
      },
    },

    dialogCancelBtn: {
      background: "#8a8a8a",
    },

    dialogStyles: {
      "& .MuiPaper-root": {
        width: "100%",
        maxWidth: "400px",
        borderRadius: "20px",
        paddingBottom: "1.25rem",
      },
    },

    dialogActionStyles: {
      display: "flex",
      justifyContent: "space-between",
      margin: "auto 1rem",
    },

    dialogDeleteBtnStyles: {
      "&:hover": {
        background: "#ff0000",
      },
    },

    accordionSection: {
      margin: "2rem 0",
    },

    mobileHeading: {
      display: "flex",
      alignItems: "center",
      paddingLeft: "1rem",
    },

    accordionDetails: {
      display: "flex",
      alignItems: "center",
      "& > section": {
        flex: "2 1 33%",
        textAlign: "center",
      },
    },
    paginatorUl: {
      justifyContent: "center",
      padding: "10px",
    },
    paginationIcon: {
      color: "white",
      marginRight: 20,
      marginLeft: 20,
      cursor: "pointer",
      backgroundColor: "#3a85d3",
      "&:hover": {},
    },
    disabledPaginationIcon: {
      color: "white",
      marginRight: 20,
      marginLeft: 20,
      backgroundColor: "grey",
      "&:hover": {},
    },
  }));

  const classes = useStyles();

  const loadingUserLoader = () => {
    var tableCell = [];
    for (let i = 0; i < usersPerPage; i++) {
      tableCell.push(
        <TableRow key={i}>
          <TableCell className={classes.tableHeaderStyles}>
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <Skeleton animation="wave" />
          </TableCell>

          <TableCell
            component="th"
            scope="row"
            className={classes.tableCellStyles}
          >
            <IconButton aria-label="delete">
              <DeleteForeverIcon className={classes.deleteIconStyles} />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    }
    return tableCell;
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <section>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {/* select all checkbox */}
              <TableCell className={classes.tableHeaderStyles}>
                <Checkbox
                  indeterminate={
                    numSelectedRows > 0 &&
                    numSelectedRows < users?.length &&
                    !selectAllClicked
                  }
                  checked={
                    numSelectedRows > 0 &&
                    numSelectedRows === users?.length &&
                    selectAllClicked
                  }
                  onClick={(e) => {
                    handleSelectAllUsers(e);
                  }}
                />
              </TableCell>
              <TableCell className={classes.tableHeaderStyles}>Sr.</TableCell>
              <TableCell className={classes.tableHeaderStyles}>
                User Name
              </TableCell>

              <TableCell className={classes.tableHeaderStyles}>
                UserGroup Name
              </TableCell>

              <TableCell className={classes.tableHeaderStyles}></TableCell>
            </TableRow>
          </TableHead>
          {loadingUsers ? (
            <TableBody>
              <>{loadingUserLoader()}</>
            </TableBody>
          ) : (
            <TableBody>
              <>
                {users
                  ?.slice(
                    (userPage - 1) * usersPerPage,
                    userPage * usersPerPage
                  )
                  .map((user, index) => (
                    <TableRow key={user.user_id}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCellStylesSrNum}
                      >
                        {/* checkbox to select each individual table row */}
                        <Checkbox
                          onChange={(e) => {
                            handleRowSelectionChanged(e, user?.user_id);
                          }}
                          checked={
                            selectedUsers.includes(user?.user_id) ||
                            selectAllClicked
                          }
                        />
                      </TableCell>

                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tableCellStylesSrNum}
                      >
                        {index + (userPage - 1) * usersPerPage + 1}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        onClick={() => handleUserClick(user.user_id)}
                        className={classes.userGroups}
                      >
                        {user.userName}
                      </TableCell>

                      <TableCell className={classes.tableCellStyles}>
                        {returnGroupName(user.userGroup)?.name}
                      </TableCell>
                      <TableCell className={classes.tableCellStyles}>
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            handleOpenDeleteUserDialog(user.user_id);
                          }}
                        >
                          <DeleteForeverIcon
                            className={classes.deleteIconStyles}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <span style={{ justifyContent: "center", display: "flex" }}>
        <Avatar
          className={
            userPage > 1
              ? classes.paginationIcon
              : classes.disabledPaginationIcon
          }
          onClick={() => handlePageBack()}
        >
          <ArrowBackIosNewIcon />
        </Avatar>

        <Typography style={{ alignSelf: "center" }}>{userPage}</Typography>
        <Avatar
          className={
            search
              ? userPage * usersPerPage < users.length
                ? classes.paginationIcon
                : classes.disabledPaginationIcon
              : userPage !== finalPageCount || finalPageCount === null
              ? classes.paginationIcon
              : classes.disabledPaginationIcon
          }
          onClick={() => handlePageForward()}
        >
          <ArrowForwardIosIcon />
        </Avatar>
      </span>
    </section>
  );
};

export default SelectTable;
